<template>
    <div>
        <div class="d-flex justify-content-center mb-3" v-if="!fluxo || aba != 'marcacao'">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'valid' ? 'active' : ''" @click.prevent="abrir('valid')">
                        <i class="fa-solid fa-prescription-bottle-medical mr-2"></i>
                        Validação Prescrição
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'planejamento' ? 'active' : ''" @click.prevent="abrir('planejamento')">
                        <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                        Planejamento
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'marcacao' ? 'active' : ''" @click.prevent="abrir('marcacao')">
                        <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                        Marcação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'confirmacao' ? 'active' : ''" @click.prevent="abrir('confirmacao')">
                        <i class="fas fa-user-check fa-fw mr-2"></i>
                        Confirmação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'bloqueio' ? 'active' : ''" @click.prevent="abrir('bloqueio')" >
                        <i class="fa fa-ban fa-fw mr-2" aria-hidden="true"></i>
                        Bloqueios
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'mapasala' ? 'active' : ''" @click.prevent="abrir('mapasala')" >
                        <i class="fa-solid fa-chair fa-fw mr-2"></i>
                        Poltronas
                    </a>
                </li>
            </ul>
        </div>

        <planejamento-infusao
            v-if="aba == 'planejamento'" />

        <marcacao 
            v-if="aba == 'marcacao'" 
            :cc="true"
            :infusao="true"
            :autorizacao="autorizacao"
            :remarcacao="remarcacao"
            :id_infusao="infusao ? infusao.id_infusao : null"
            :dados_infusao="infusao"
            @fluxo="estado" />

        <confirmacao
            v-if="aba == 'confirmacao'" />
            
        <bloqueio
            :cc="true"
            :infusao="true"
            v-if="aba == 'bloqueio'" />

        <mapa-de-sala v-if="aba == 'mapasala'" />

        <validacao-prescricao v-if="aba == 'valid'" />
        
    </div>
</template>

<script>
import Marcacao from '../callcenter/Marcacao.vue';
import Confirmacao from '../callcenter/Confirmacao.vue';
import Bloqueio from '../callcenter/Bloqueio.vue';
import MapaDeSala from '../callcenter/MapaDeSala.vue';
import PlanejamentoInfusao from './PlanejamentoInfusao.vue';
import ValidacaoPrescricao from '../enfermagem/ValidacaoPrescricao.vue';

export default {
    data() { 
        return { 
            fluxo: null, 
        };
    },

    components: { 
        Marcacao, 
        Bloqueio,
        MapaDeSala,  
        Confirmacao,
        PlanejamentoInfusao,
        ValidacaoPrescricao, 
    }, 

    props: ['aba', 'autorizacao', 'infusao', 'remarcacao'], 

    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/infusao/' + aba });
            }

            this.set_bread(aba);
        },

        set_bread (aba) { 
            if ( aba == 'marcacao' ) { 

                this.$store.commit(
                    'setBreadcrumb', 
                    [
                        { name: "Infusão", path: "/infusao/planejamento" },
                        { name: "Marcação", path: "/infusao/marcacao"}
                    ]
                );

            }
        }
    },

    mounted() { 
        this.set_bread(this.aba);
    }
}
</script>